if (!customElements.get('product-v2-variant-picker')) {
  customElements.define(
    'product-v2-variant-picker',
    class ProductV2VariantPicker extends HTMLElement {
      constructor() {
        super();
        this.onSizeGuideClick = this.onSizeGuideClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onSizeGuideClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onSizeGuideClick);
      }

      onSizeGuideClick(event) {
        const trigger = event.target.closest('[data-size-guide-trigger]');
        if (!trigger || !this.contains(trigger)) return;

        event.preventDefault();
        event.stopPropagation();
        customElements.get('product-v2-size-guide')?.openFromTrigger(trigger);
      }
    }
  );
}
